import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { LocalStorageService, ObjetsService } from '../../shared';

@Component({
  selector: 'app-form-validation',
  templateUrl: './app-form-validation.component.html',
  providers: [ObjetsService]
})
export class AppFormValidationComponent implements OnInit {

  public idCerfa;
  public formArray;
  public showValidMessageSuccess = true;
  public showValidMessageError = true;
  public toValid = true;
  public validLoading = false;
  public formRecapAffiche = false;
  public listFiles: string[];

  form: FormGroup;
  items: FormArray;

  private alive = true;

  constructor(
    private _objetsService: ObjetsService,
    private changeDetector: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private cookieService: CookieService,
    private localStorageService: LocalStorageService
  ) { }

  get formData() { return <FormArray>this.form.get('items'); }

  ngOnInit() {
    this.form = new FormGroup({
      app_form_validation: new FormControl(),
    });

    this.form = this.formBuilder.group({
      items: this.formBuilder.array([ this.createItem() ])
    });

    // this.form.get('items').get('0').get('app_form_validation').disable();
  }

  getCountryName(code: string): string {
    return this._objetsService.getCountry()[code];
  }

  getLibelleProfession(profession: any): string {
    if(profession != null) {
      return profession.lib;
    } else {
      return '';
    }
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      app_form_validation: '',
    });
  }

  startFormValidation(validation): void {
    if (validation) {
      this.loadValidationForm();
    }
  }

  printRecapPDF(): void {
    this._objetsService.printPDFCerfa(this.idCerfa);
  }

  displayMontant(value: string): string {
    if(value == null) return '';

    value = value.replace('.', ',');
    return value + " €";
  }

  calculerSuperficieTotale(): number {
    // Recalcul des superficies pour éviter les bugs
    let rubriqueBSuperficieTotale = 0;
    this.formArray.rubrique_B_situation_bien.b_ref_cad.forEach(item => {
      rubriqueBSuperficieTotale += item.refcad_superficie;
    });

    return rubriqueBSuperficieTotale;
  }

  /**
   * Appel le webservice de validation du formulaire préalablement enregistré
   *
   * @returns {any}
   */
  loadValidationForm(): any {
    this.validLoading = true;

    this.formArray.rubrique_B_situation_bien.b_adresse__superficie = this.calculerSuperficieTotale();
    return this._objetsService.validationForm(this.formArray, this.idCerfa).takeWhile(() => this.alive).subscribe(
      data => {
        if (data.type !== undefined) {
          this.validLoading = false;
          if (data.type === 'success') {
            this.toValid = false;
            this.showValidMessageSuccess = false;
            this.showValidMessageError = true;
            // Supprimer le brouillon après envoi réussi
            this.localStorageService.clearAll();
            // Signaler la soumission pour empêcher la ré-écriture/restauration du wizard state
            sessionStorage.setItem('dia_form_submitted', 'true');
          } else {
            this.showValidMessageSuccess = true;
            this.showValidMessageError = false;
            this.form.get('items').get('0').get('app_form_validation').setValue(false);
          }
        }
      },
      err => {
        console.log(err);
        this.validLoading = false;
        this.showValidMessageSuccess = true;
        this.showValidMessageError = false;
        this.form.get('items').get('0').get('app_form_validation').setValue(false);
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/app-form-validation/app-form-validation.component.ts